import { render, staticRenderFns } from "./EmailInput.vue?vue&type=template&id=4840b722&scoped=true"
import script from "./EmailInput.vue?vue&type=script&lang=js"
export * from "./EmailInput.vue?vue&type=script&lang=js"
import style0 from "./EmailInput.vue?vue&type=style&index=0&id=4840b722&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4840b722",
  null
  
)

export default component.exports